export default {
    hubNames(state) {
        return state.hubNames
    },

    services(state) {
        return state.services;
    }
}
